import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'

const PrayerTimeIkim = ({ backgroundColor = '', fontColor = 'white' }) => {
  const [prayerInfo, setPrayerInfo] = useState({})
  const islamicMonths = [
    'MUHARRAM',
    'SAFAR',
    'RABIULAWAL',
    'RABIULAKHIR',
    'JAMADIULAWAL',
    'JAMADILAKHIR',
    'RAJAB',
    'SYAABAN',
    'RAMADHAN',
    'SYAWAL',
    'ZULKAEDAH',
    'ZULHIJJAH',
  ]

  const fetchPrayerData = async () => {
    const dayOfMonth = moment().date()

    fetch(`https://api.waktusolat.app/solat/WLY01/${dayOfMonth}`)
      .then((blob) => blob.json())
      .then((data) => {
        console.log(data)
        if (!isEmpty(data?.prayerTime)) {
          let tempObj = {}

          let islamicMonthIndex = data.prayerTime.hijri.split('-')[1]
          tempObj['monthName'] = islamicMonths[parseInt(islamicMonthIndex) - 1]
          tempObj['islamicYear'] = data.prayerTime.hijri.split('-')[0]
          tempObj['islamicDate'] = data.prayerTime.hijri.split('-')[2]

          setPrayerInfo({ ...tempObj, ...data.prayerTime })
        }
      })
      .catch((e) => {
        console.log(e)
        return e
      })
  }

  useEffect(() => {
    fetchPrayerData()
  }, [])
  return (
    <div
      style={{
        // backgroundImage: `linear-gradient(to bottom, ${backgroundColor}, ${backgroundColor}50)`,
        background: `linear-gradient(180deg, ${backgroundColor} 0%, ${backgroundColor}40 100%) 0% 0% no-repeat padding-box`,
        color: fontColor,
      }}
      className="w-full flex justify-center items-center h-[29px] prayer-time-scroll-text"
    >
      <div className="flex xl:justify-between items-center text-[10px] xl:text-xs 2xl:text-sm xl:w-[97%] 2xl:w-[1658px] ">
        <div className="mx-2 xl:ml-0">
          <p className="font-semibold">WAKTU SOLAT KUALA LUMPUR. PUTRAJAYA</p>
        </div>
        <div className="flex items-center font-semibold mx-2 xl:ml-0">
          <p className="">{moment().format('DD MMM YYYY')}</p>
          <p className="mx-2">|</p>
          <p className="">
            {isEmpty(prayerInfo)
              ? 'Loading...'
              : `${prayerInfo.islamicDate} ${prayerInfo.monthName} ${prayerInfo.islamicYear}H`}
          </p>
        </div>
        <div className="flex items-center mx-2 xl:ml-0">
          <div className="flex items-center">
            <p className="font-semibold">IMSAK</p>
            <p className="pl-1">
              {isEmpty(prayerInfo)
                ? 'Loading...'
                : moment(`${prayerInfo.date} ${prayerInfo.fajr}`)
                    .subtract(10, 'minutes')
                    .format('hh:mm A')}
            </p>
            <p className="mx-2">|</p>
          </div>
          <div className="flex items-center">
            <p className="font-semibold">SUBUH</p>
            <p className="pl-1">
              {isEmpty(prayerInfo)
                ? 'Loading...'
                : moment(`${prayerInfo.date} ${prayerInfo.fajr}`).format('hh:mm A')}
            </p>
            <p className="mx-2">|</p>
          </div>
          <div className="flex items-center">
            <p className="font-semibold">ZOHOR</p>
            <p className="pl-1">
              {isEmpty(prayerInfo)
                ? 'Loading...'
                : moment(`${prayerInfo.date} ${prayerInfo.dhuhr}`).format('hh:mm A')}
            </p>
            <p className="mx-2">|</p>
          </div>
          <div className="flex items-center">
            <p className="font-semibold">ASAR</p>
            <p className="pl-1">
              {isEmpty(prayerInfo)
                ? 'Loading...'
                : moment(`${prayerInfo.date} ${prayerInfo.asr}`).format('hh:mm A')}
            </p>
            <p className="mx-2">|</p>
          </div>
          <div className="flex items-center">
            <p className="font-semibold">MAGHRIB</p>
            <p className="pl-1">
              {isEmpty(prayerInfo)
                ? 'Loading...'
                : moment(`${prayerInfo.date} ${prayerInfo.maghrib}`).format('hh:mm A')}
            </p>
            <p className="mx-2">|</p>
          </div>
          <div className="flex items-center">
            <p className="font-semibold">ISYAK</p>
            <p className="pl-1">
              {isEmpty(prayerInfo)
                ? 'Loading...'
                : moment(`${prayerInfo.date} ${prayerInfo.isha}`).format('hh:mm A')}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrayerTimeIkim
